import ObservationHistoryCard from "./ObservationHistoryCard";

export default ObservationHistoryCard;
